import React, { useCallback, useMemo } from 'react'
import KeyboardNavigator from 'components/KeyboardNavigator'
import Scroller from 'components/Scroller'
import { ENTER } from 'constants/keys'
import { throttle } from 'util/functions'
import Item from './Item'
import Header from './Header'
import Search from './Search'
import useShowHeaderShadow from './useShowSearchBorder'
import { styles } from './styles'

const KEYBOARD_NAVIGATOR_KEYS = { select: [ENTER] }

const MenuWithSearch = ({
  focusElementRef,
  children,
  search,
  className,
  onScroll,
}) => {
  const throttledHandleScroll = useMemo(
    () => {
      return throttle(scrollTop => {
        onScroll(scrollTop)
      }, 100)
    },
    [onScroll]
  )

  const handleScroll = useCallback(
    e => {
      throttledHandleScroll(e.target.scrollTop)
    },
    [throttledHandleScroll]
  )

  return (
    <KeyboardNavigator
      activeKey={search}
      keys={KEYBOARD_NAVIGATOR_KEYS}
      focusElement={focusElementRef?.current}
    >
      <Scroller>
        <div
          css={styles.container}
          onScroll={onScroll ? handleScroll : undefined}
          role="menu"
          className={className}
        >
          {children}
        </div>
      </Scroller>
    </KeyboardNavigator>
  )
}

MenuWithSearch.Item = Item
MenuWithSearch.Header = Header
MenuWithSearch.Search = Search
MenuWithSearch.styles = styles
MenuWithSearch.useShowHeaderShadow = useShowHeaderShadow

export default MenuWithSearch
